import { PackageVersionModule } from '@/pages/report/package/versions/types'
import DocumentPreview from '@/pages/report/package/versions/v2/document/DocumentPreview.vue'
import {
  formatPackageDataRequest,
  formatPackageDataResponse,
} from '@/pages/report/package/versions/v2/formatPackageData'
import { buildManualPackageData } from '@/pages/report/package/versions/v2/manualPackageData'

const packageVersionV2: PackageVersionModule = {
  DocumentPreview,
  formatPackageDataRequest,
  formatPackageDataResponse,
  buildManualPackageData,
}

export default packageVersionV2
